$(document).on('turbolinks:load', function() {
    $(function() {
        $('#sequencial-switch').bootstrapToggle({
            width: '100',
        });
        $('#sequencial-switch').on('change', function() {
            location.href = $('#sequencial-switch').attr("data-url");
        })
    });
});